// import { OrderDetail } from 'widgets/orderDetail';
import { Container, MarginLeft } from './styles';
import { OrderInfoProvider } from 'entities/orders';
import { FC } from 'react';
import { usePaginationFilter } from 'shared/lib/pagination';
import { Booking } from 'widgets/booking';
import { OrderPlaceHolder } from './orderPlaceHolder';
import { OrderDashboardProps } from './types';
import { OrderDetailInfo } from 'widgets/orderDetail/ui/order/orderDetailInfo';
import { OrderDetail } from 'widgets/orderDetail';

export const OrderDashboard: FC<OrderDashboardProps> = ({
	children,
	goToBooking = false,
	marginLeft = true,
	includeOrderDetailButtons = true,
	includePenButtonInOrderDetail = true,
	includeCloseButtonInOrderDetail = true,
	maxHeightOrderDetail = '',
  heightPanel = '',
	placeholder = '',
	includeContactInfo = true,
	orderDetailInfoTitle,
	softDesign = false,
	newApplicationBtn = false,
	updateOrderInPersonModal,
  isModal = false,
  isOnlyInfo = false,
}) => {
	const paginationFilter = usePaginationFilter();

	return (
		<OrderInfoProvider>
			<Container>
				<Booking
					resetPersonAfterClose={true}
				/>
				<MarginLeft $left={marginLeft}>{children}</MarginLeft>
        {isOnlyInfo ?
				<OrderDetailInfo
					goToBookingBtn={goToBooking}
					fetchData={paginationFilter?.fetchDataWithDispatch}
					includeButtons={includeOrderDetailButtons}
					maxHeightPanel={maxHeightOrderDetail}
          heightPanel={heightPanel}
					includePenButton={includePenButtonInOrderDetail}
					includeContactInfo={includeContactInfo}
					includeCloseButton={includeCloseButtonInOrderDetail}
					infoTitle={orderDetailInfoTitle}
					softDesign={softDesign}
					updateOrderInPersonModal={updateOrderInPersonModal}
          isModal={isModal}
				/> : 
				<OrderDetail
					goToBookingBtn={goToBooking}
					fetchData={paginationFilter?.fetchDataWithDispatch}
					includeButtons={includeOrderDetailButtons}
					maxHeightPanel={maxHeightOrderDetail}
          heightPanel={heightPanel}
					includePenButton={includePenButtonInOrderDetail}
					includeContactInfo={includeContactInfo}
					includeCloseButton={includeCloseButtonInOrderDetail}
					infoTitle={orderDetailInfoTitle}
					softDesign={softDesign}
					updateOrderInPersonModal={updateOrderInPersonModal}
          isModal={isModal}
				/>
        }
				<OrderPlaceHolder
					placeholder={placeholder}
					newApplicationBtn={newApplicationBtn}
				/>
			</Container>
		</OrderInfoProvider>
	);
};
